import { Box } from '@chakra-ui/react';
import { antlerStyle } from '@constants/styles';

const HeroContainer = ({ children }) => {
  return (
    <Box minH={`calc(75vh - ${antlerStyle.navHeight})`} px={antlerStyle.px} pt={4} pb={8}>
      {children}
    </Box>
  );
};

export default HeroContainer;
